import { PaginationState } from 'app/shared/pagination/pagination.model';
import { useQuery } from '@tanstack/react-query';
import {
  fetchPublicAuthorityOverview
} from 'app/edozvola/public-authority-overview/service/public-authority-overview.service';
import {
  PublicAuthorityOverviewFilterModel
} from 'app/edozvola/public-authority-overview/model/public-authority-overview.model';

export const fetchPublicAuthorityOverviewQuery = (pagination: PaginationState, filterDto: PublicAuthorityOverviewFilterModel) => {
  return useQuery({
    queryKey: ['public-authority-overview', { ...pagination }, { ...filterDto }],
    queryFn: () => fetchPublicAuthorityOverview(pagination, filterDto),
  });
};
